import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: '',
        userInfo: '',
        moneyWay: [
          {
            values: [
                {
                    "key": 0,
                    "name": '信用'
                },
                {
                    "key": 1,
                    "name": '抵押'
                },
                {
                    "key": 3,
                    "name": '质押'
                },
                {
                    "key": 4,
                    "name": '一般保证'
                },
                {
                    "key": 9,
                    "name": '不限'
                }
            ],
          }
        ],
        financeWay: [
            {"name": '不限', isActive: true, id: '0'}, 
            {"name": '银行', isActive: false, id: '1'},
            {"name": '担保公司', isActive: false, id: '2'},
            {"name": '保险公司', isActive: false, id: '3'}, 
            {"name": '金融租赁', isActive: false, id: '4'}
        ],
        dateLimit: [
            {
                values:[
                    {
                        "key": 3,
                        "name": '3个月'
                    },
                    {
                        "key": 6,
                        "name": '6个月'
                    },
                    {
                        "key": 12,
                        "name": '12个月'
                    },
                    {
                        "key": 24,
                        "name": '24个月'
                    },
                    {
                        "key": 36,
                        "name": '36个月'
                    },
                    {
                        "key": 60,
                        "name": '60个月'
                    },
                    {
                        "key": 0,
                        "name": '60个月以上'
                    }
                ]
            }
        ],
        monFuction: [
            {
                values:[
                    {
                        "name": '流动资金周转'
                    },
                    {
                        "name": '厂房扩建'
                    },
                    {
                        "name": '贷款'
                    },
                    {
                        "name": '购买原材料'
                    },
                    {
                        "name": '添加设备'
                    },
                    {
                        "name": '其他'
                    }
                ]
            }
        ],
        //所属市
        companyCity: [
            {key:'10', value:'合肥'},
            {key:'11', value:'芜湖'},
            {key:'12', value:'蚌埠'},
            {key:'13', value:'淮南'},
            {key:'14', value:'马鞍山'},
            {key:'15', value:'淮北'},
            {key:'16', value:'铜陵'},
            {key:'17', value:'安庆'},
            {key:'18', value:'黄山'},
            {key:'19', value:'阜阳'},
            {key:'20', value:'宿州'},
            {key:'21', value:'滁州'},
            {key:'22', value:'六安'},
            {key:'23', value:'宣城'},
            {key:'24', value:'池州'},
            {key:'25', value:'亳州'}
        ],
        city:  [{
                    "code": "340100",
                    "name": "合肥",
                    "sub": [{
                        "code": "340102",
                        "name": "瑶海区"
                    }, {
                        "code": "340103",
                        "name": "庐阳区"
                    }, {
                        "code": "340104",
                        "name": "蜀山区"
                    }, {
                        "code": "340111",
                        "name": "包河区"
                    }, {
                        "code": "340121",
                        "name": "长丰县"
                    }, {
                        "code": "340122",
                        "name": "肥东县"
                    }, {
                        "code": "340123",
                        "name": "肥西县"
                    }, {
                        "code": "340124",
                        "name": "庐江县"
                    }, {
                        "code": "340181",
                        "name": "巢湖市"
                    }],
                    "type": 0
                }, {
                    "code": "340200",
                    "name": "芜湖",
                    "sub": [{
                        "code": "340202",
                        "name": "镜湖区"
                    }, {
                        "code": "340203",
                        "name": "弋江区"
                    }, {
                        "code": "340207",
                        "name": "鸠江区"
                    }, {
                        "code": "340208",
                        "name": "三山区"
                    }, {
                        "code": "340221",
                        "name": "芜湖县"
                    }, {
                        "code": "340222",
                        "name": "繁昌县"
                    }, {
                        "code": "340223",
                        "name": "南陵县"
                    }, {
                        "code": "340225",
                        "name": "无为县"
                    }],
                    "type": 0
                }, {
                    "code": "340300",
                    "name": "蚌埠",
                    "sub": [{
                        "code": "340302",
                        "name": "龙子湖区"
                    }, {
                        "code": "340303",
                        "name": "蚌山区"
                    }, {
                        "code": "340304",
                        "name": "禹会区"
                    }, {
                        "code": "340311",
                        "name": "淮上区"
                    }, {
                        "code": "340321",
                        "name": "怀远县"
                    }, {
                        "code": "340322",
                        "name": "五河县"
                    }, {
                        "code": "340323",
                        "name": "固镇县"
                    }],
                    "type": 0
                }, {
                    "code": "340400",
                    "name": "淮南",
                    "sub": [{
                        "code": "340402",
                        "name": "大通区"
                    }, {
                        "code": "340403",
                        "name": "田家庵区"
                    }, {
                        "code": "340404",
                        "name": "谢家集区"
                    }, {
                        "code": "340405",
                        "name": "八公山区"
                    }, {
                        "code": "340406",
                        "name": "潘集区"
                    }, {
                        "code": "340421",
                        "name": "凤台县"
                    }, {
                        "code": "340422",
                        "name": "寿县"
                    }],
                    "type": 0
                }, {
                    "code": "340500",
                    "name": "马鞍山",
                    "sub": [{
                        "code": "340503",
                        "name": "花山区"
                    }, {
                        "code": "340504",
                        "name": "雨山区"
                    }, {
                        "code": "340506",
                        "name": "博望区"
                    }, {
                        "code": "340521",
                        "name": "当涂县"
                    }, {
                        "code": "340522",
                        "name": "含山县"
                    }, {
                        "code": "340523",
                        "name": "和县"
                    }],
                    "type": 0
                }, {
                    "code": "340600",
                    "name": "淮北",
                    "sub": [{
                        "code": "340602",
                        "name": "杜集区"
                    }, {
                        "code": "340603",
                        "name": "相山区"
                    }, {
                        "code": "340604",
                        "name": "烈山区"
                    }, {
                        "code": "340621",
                        "name": "濉溪县"
                    }],
                    "type": 0
                }, {
                    "code": "340700",
                    "name": "铜陵",
                    "sub": [{
                        "code": "340705",
                        "name": "铜官区"
                    }, {
                        "code": "340706",
                        "name": "义安区"
                    }, {
                        "code": "340711",
                        "name": "郊区"
                    }, {
                        "code": "340722",
                        "name": "枞阳县"
                    }],
                    "type": 0
                }, {
                    "code": "340800",
                    "name": "安庆",
                    "sub": [{
                        "code": "340802",
                        "name": "迎江区"
                    }, {
                        "code": "340803",
                        "name": "大观区"
                    }, {
                        "code": "340811",
                        "name": "宜秀区"
                    }, {
                        "code": "340822",
                        "name": "怀宁县"
                    }, {
                        "code": "340825",
                        "name": "太湖县"
                    }, {
                        "code": "340826",
                        "name": "宿松县"
                    }, {
                        "code": "340827",
                        "name": "望江县"
                    }, {
                        "code": "340828",
                        "name": "岳西县"
                    }, {
                        "code": "340881",
                        "name": "桐城市"
                    }, {
                        "code": "340882",
                        "name": "潜山市"
                    }],
                    "type": 0
                }, {
                    "code": "341000",
                    "name": "黄山",
                    "sub": [{
                        "code": "341002",
                        "name": "屯溪区"
                    }, {
                        "code": "341003",
                        "name": "黄山区"
                    }, {
                        "code": "341004",
                        "name": "徽州区"
                    }, {
                        "code": "341021",
                        "name": "歙县"
                    }, {
                        "code": "341022",
                        "name": "休宁县"
                    }, {
                        "code": "341023",
                        "name": "黟县"
                    }, {
                        "code": "341024",
                        "name": "祁门县"
                    }],
                    "type": 0
                }, {
                    "code": "341100",
                    "name": "滁州",
                    "sub": [{
                        "code": "341102",
                        "name": "琅琊区"
                    }, {
                        "code": "341103",
                        "name": "南谯区"
                    }, {
                        "code": "341122",
                        "name": "来安县"
                    }, {
                        "code": "341124",
                        "name": "全椒县"
                    }, {
                        "code": "341125",
                        "name": "定远县"
                    }, {
                        "code": "341126",
                        "name": "凤阳县"
                    }, {
                        "code": "341181",
                        "name": "天长市"
                    }, {
                        "code": "341182",
                        "name": "明光市"
                    }],
                    "type": 0
                }, {
                    "code": "341200",
                    "name": "阜阳",
                    "sub": [{
                        "code": "341202",
                        "name": "颍州区"
                    }, {
                        "code": "341203",
                        "name": "颍东区"
                    }, {
                        "code": "341204",
                        "name": "颍泉区"
                    }, {
                        "code": "341221",
                        "name": "临泉县"
                    }, {
                        "code": "341222",
                        "name": "太和县"
                    }, {
                        "code": "341225",
                        "name": "阜南县"
                    }, {
                        "code": "341226",
                        "name": "颍上县"
                    }, {
                        "code": "341282",
                        "name": "界首市"
                    }],
                    "type": 0
                }, {
                    "code": "341300",
                    "name": "宿州",
                    "sub": [{
                        "code": "341302",
                        "name": "埇桥区"
                    }, {
                        "code": "341321",
                        "name": "砀山县"
                    }, {
                        "code": "341322",
                        "name": "萧县"
                    }, {
                        "code": "341323",
                        "name": "灵璧县"
                    }, {
                        "code": "341324",
                        "name": "泗县"
                    }],
                    "type": 0
                }, {
                    "code": "341500",
                    "name": "六安",
                    "sub": [{
                        "code": "341502",
                        "name": "金安区"
                    }, {
                        "code": "341503",
                        "name": "裕安区"
                    }, {
                        "code": "341504",
                        "name": "叶集区"
                    }, {
                        "code": "341522",
                        "name": "霍邱县"
                    }, {
                        "code": "341523",
                        "name": "舒城县"
                    }, {
                        "code": "341524",
                        "name": "金寨县"
                    }, {
                        "code": "341525",
                        "name": "霍山县"
                    }],
                    "type": 0
                }, {
                    "code": "341600",
                    "name": "亳州",
                    "sub": [{
                        "code": "341602",
                        "name": "谯城区"
                    }, {
                        "code": "341621",
                        "name": "涡阳县"
                    }, {
                        "code": "341622",
                        "name": "蒙城县"
                    }, {
                        "code": "341623",
                        "name": "利辛县"
                    }],
                    "type": 0
                }, {
                    "code": "341700",
                    "name": "池州",
                    "sub": [{
                        "code": "341702",
                        "name": "贵池区"
                    }, {
                        "code": "341721",
                        "name": "东至县"
                    }, {
                        "code": "341722",
                        "name": "石台县"
                    }, {
                        "code": "341723",
                        "name": "青阳县"
                    }],
                    "type": 0
                }, {
                    "code": "341800",
                    "name": "宣城",
                    "sub": [{
                        "code": "341802",
                        "name": "宣州区"
                    }, {
                        "code": "341821",
                        "name": "郎溪县"
                    }, {
                        "code": "341822",
                        "name": "广德县"
                    }, {
                        "code": "341823",
                        "name": "泾县"
                    }, {
                        "code": "341824",
                        "name": "绩溪县"
                    }, {
                        "code": "341825",
                        "name": "旌德县"
                    }, {
                        "code": "341881",
                        "name": "宁国市"
                    }],
                    "type": 0
        }]
    },
    mutations: {
        //存储token方法
        //设置token等于外部传递进来的值
        setToken(state, token) {
            state.token = token
            localStorage.token = token //同步存储token至localStorage
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
            localStorage.userInfo = userInfo //同步存储token至localStorage
        },
        // setUserState(state, userInfo) {
        //     state.userInfo.setUserState = userInfo.setUserState
        //     localStorage.userInfo.setUserState = userInfo.setUserState //同步存储token至localStorage
        // }
    },
    getters : {
        //获取token方法
        //判断是否有token,如果没有重新赋值，返回给state的token
        getToken(state) {
            if (!state.token) {
                state.token = localStorage.getItem('token')
            }
            return state.token
        },
        getUserInfo(state) {
            if (!state.userInfo) {
                state.userInfo = localStorage.getItem('userInfo')
            }
            return state.userInfo
        },
        // getUserState(state) {
        //     if (!state.userInfo.userState) {
        //         state.userInfo.userState = localStorage.getItem('userState')
        //     }
        //     return state.userInfo.userState
        // }
    },
    actions: {
    
    }
})



// WEBPACK FOOTER //
// ./src/store.js